import React from "react";
import { useControlCenterState } from "./hooks/useControlCenterState.js";
import { ControlCenterDataLoadable } from "./index.js";

export const ControlCenterLoader = () => {
  const enabled = useControlCenterState();
  return enabled && <ControlCenterDataLoadable />;
};
